/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import { showModal, getCertificate } from "actions";
// import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { ReactComponent as SvgDownloadCertificate } from "components/widgets/training/download-certificate.svg";
import { ReactComponent as SvgViewDocuments } from "components/widgets/training/view-documents.svg";
import "components/widgets/training/Training.css";
import TrainingDetailDocuments from "./TrainingDetailDocuments";
import { SCORMURL, ENV_NAME } from "util/constant";
import { Trans } from "react-i18next";
import i18n from "i18next";
import Helpers from "util/helpers";

class CompletedTraining extends Component {
  state = {
    showingChildren: false,
  };

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  handleCertificateDownload = (certNo) => {
    this.props.getCertificate(
      certNo,
      this.onDownloadBegin,
      this.onDownloadSuccess,
      this.onDownloadError
    );
  };

  onDownloadBegin = () => { };
  onDownloadError = (err) => {
    console.log(err);
  };

  onDownloadSuccess = (res, fname) => {
    let a = window.document.createElement("a");
    a.setAttribute("href", URL.createObjectURL(res.data));
    a.setAttribute("target", "_blank");
    a.setAttribute("download", fname);
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  showDetail = (t) => {
    // Eğitim Dökümanları = 10517
    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: i18n.t("10517"),
      modalContent: <TrainingDetailDocuments trainingId={t.training.id} />,
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderTrainingMethodIcon = (value) => {
    switch (value) {
      case 3:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-tv">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </span>
          </td>
        );
      case 1:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-live-tv "></span>
          </td>
        );
      default:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-class"></span>
          </td>
        );
    }
  };

  renderCertificationIcon = (t) => {
    if (!t.certificationNo) return null;

    return (
      <SvgDownloadCertificate
        className="training-table__icon-dwncert"
        onClick={() => this.handleCertificateDownload(t.certificationNo)}
      />
    );
  };

  renderDocumentIcon = (t) => {
    if (!t.hasDocument) return null;

    return (
      <SvgViewDocuments
        onClick={() => this.showDetail(t)}
        className="training-table__icon-viewdoc"
      />
    );

    // console.dir(t);
  };

  renderScoreChart = (t) => {
    // console.log(t);
    if (t.score === null) return null;
    let color = "red";
    if (51 <= t.score && t.score < 76) color = "orange";
    if (t.score >= 76) color = "green";
    return (
      <>
        <div
          id="statusCalendarChart_1"
          className="statusCalendarChart"
          data-percent={t.score}
        >
          <div>
            <div className="single-chart">
              <svg viewBox="-2 -2 40 40" className={`circular-chart ${color}`}>
                <path
                  className="circle-bg"
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <path
                  className="circle"
                  strokeDasharray={`${t.score}, 100`}
                  d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
                ></path>
                <text x="18" y="22.35" className="percentage">
                  {t.score}
                </text>
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  };

  renderTrainingName = (t) => {
    return (<>
      {t.isRoleTraining && <i className="role-egitim mr-1"></i>}
      {t.isTargetTraining && <i className="hedeflenen-egitim mr-1"></i>}
      {t.training.name}
    </>);
  }

  renderContinueAction = (training) => {
    let url = "";
    let langCode = Helpers.getLangCode(localStorage.getItem("i18nextLng"));
    switch (training.buttonType) {
      case "Play":


        // url = `${SCORMURL}/index?employeeCode=${this.props.employeeCode}&registeredTrainingId=${training.employeeRegisteredTrainingId}&langCode=${langCode}&env=${ENV_NAME}`;
        
        const postUrl = `${SCORMURL}/index?env=${ENV_NAME}`;
        
                const payload = {
                  employeeCode: this.props.employeeCode,
                  registeredTrainingId: training.employeeRegisteredTrainingId,
                  langCode: langCode,
                };
        
                url = (
                  <span
                    className="iconmford fo-icon-play-circle-outline"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      const newWindow = window.open(postUrl, "_blank");
        
                      // alıcı hazırım deyince gönder
                      const readyListener = (e) => {
                        if (e.data === "SCORM_READY") {
                          newWindow.postMessage(payload, SCORMURL);
                          window.removeEventListener("message", readyListener);
                        }
                      };
        
                      window.addEventListener("message", readyListener);
                    }}
                  />
                );
        
        
        break;
      case "Redirect":
        url = training.trainingUrl;
        break;
      default:
        url = "";
        break;
    }

    if (training.buttonType === "Play" && training.showPlayButton) {
       return ( 
        <span>  {url} </span> 
      );
      // return (
      //   <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
      //     <span className="iconmford fo-icon-play-circle-outline"></span>
      //   </a>
      // );
    } else if (training.buttonType === "Redirect" && training.method.value !== 3) {
      return (
        <a
          className="btn-redirect"
          href={url ?? "#"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Trans desc="Yönlendir">10543</Trans>
        </a>
      );
    } else {
      return null;
    }
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="5">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Başlangıç">10117</Trans>
                  </div>
                </td>
                <td className="showGrup">{Helpers.renderDate(t.startDate)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Bitiş">10118</Trans>
                  </div>
                </td>
                <td className="showGrup">{Helpers.renderDate(t.endDate)}</td>
              </tr>
              {/* <tr data-dt-row="0" data-dt-column="6">
                <td>
                  <div className="tableTitle">Başarı</div>
                </td>
                <td className="showGrup">{t.isSuccess}</td>
              </tr> */}
              {/* <tr data-dt-row="0" data-dt-column="7">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Puan">10177</Trans>
                  </div>
                </td>
                <td className="showGrup">{this.renderScoreChart(t)}</td>
              </tr> */}
              <tr data-dt-row="9" data-dt-column="7">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Dokumanlar">10178</Trans>
                  </div>
                </td>
                <td className="u-centered">{this.renderDocumentIcon(t)}</td>
              </tr>
              <tr data-dt-row="9" data-dt-column="7">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Sertifika">10179</Trans>
                  </div>
                </td>
                <td className="u-centered">
                  {this.renderCertificationIcon(t)}
                </td>
              </tr>
              <tr>
                <td>
                  <div className="tableTitle">
                    <Trans desc="Devam">10390</Trans>
                  </div>
                </td>
                <td className="u-centered">
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {this.renderContinueAction(t)}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <tr>
            {this.renderTrainingMethodIcon(t.method?.value)}
            <td className="showGrup">


              {t.programTypeCode == 0
                ? this.renderTrainingName(t)
                : <strong style={{
                  display: "inline-flex",
                  alignItems: "center",
                  "gap": "8px"
                }} >

                  <svg
                    // viewBox="0 0 360 483.3"
                    viewBox="100 100 200 200"
                    style={{
                      width: 40,
                      margin: "0 auto",
                      height: "auto",
                      boxSizing: "border-box",
                      minWidth: "40px"
                    }}
                  >
                    <title>Ford Pro Logo</title>


                    <g>
                      <g>
                        <path
                          fill="#00095B"
                          d="M107.1904297,166.3092499h18.6459961c14.2714844,0,21.9453125,6.8847656,21.9453125,18.4316406
          c0,10.8291016-8.7495117,17.4267578-19.1484375,17.4267578h-9.9682617v17.2119141h-11.4746094V166.3092499z
          M126.7685547,192.1276093c6.0961914,0,9.0366211-2.1513672,9.0366211-7.8173828
          c0-6.3105469-3.7294922-7.9609375-10.184082-7.9609375h-6.9560547v15.7783203H126.7685547z"
                        />

                        <path
                          fill="#00095B"
                          d="M154.015625,166.3092499h19.3632812c14.1992188,0,21.9453125,4.8769531,21.9453125,16.0644531
          c0,5.953125-2.2949219,9.8251953-6.5976562,12.4785156
          c4.2304688,1.3632812,6.3818359,5.0917969,6.3818359,9.6103516v14.9169922
          h-11.4746094v-13.6259766c0-4.0878906-1.9355469-5.3789062-5.378418-5.3789062h-12.7651367v19.0048828H154.015625V166.3092499z
          M174.3110352,191.0514374c6.1674805,0,9.0366211-1.8642578,9.0366211-7.7451172
          c0-5.59375-3.8012695-6.9570312-10.184082-6.9570312h-7.6733398v14.7021484H174.3110352z"
                        />

                        <path
                          fill="#00095B"
                          d="M201.9306641,193.2028046c0-18.1435547,11.4746094-27.6103516,26.0332031-27.6103516
          c14.4873047,0,24.6708984,9.4667969,24.6708984,26.75
          c0,18.0722656-11.3310547,27.7539062-25.9619141,27.7539062
          C212.1865234,220.0963593,201.9306641,210.5582733,201.9306641,193.2028046z
          M226.8164062,210.0563202c9.0361328,0,13.9130859-6.3105469,13.9130859-17.3554688
          c0-10.3984375-4.2314453-17.0683594-13.1953125-17.0683594
          c-9.0371094,0-13.7695312,6.5976562-13.7695312,17.7138672
          C213.7646484,204.0319061,218.1386719,210.0563202,226.8164062,210.0563202z"
                        />
                      </g>

                      <g>
                        <path
                          fill="#00095B"
                          d="M255.515625,167.9781952h-3.1474609v-1.7070312h8.125v1.7070312h-3.1464844v7.6923828h-1.8310547V167.9781952z
          M261.3779297,166.2711639h2.0566406l2.859375,6.9521484l2.859375-6.9521484h2.0566406v9.3994141h-1.7900391v-6.2119141
          l-2.5292969,6.2119141h-1.234375l-2.5507812-6.2119141v6.2119141h-1.7275391V166.2711639z"
                        />
                      </g>

                      <rect x="107.2" y="231.9" fill="#1700F4" width="144.8" height="15.6" />
                    </g>
                  </svg>


                  <strong> {this.renderTrainingName(t)} </strong>

                </strong>
              }





            </td>
            <td className="showGrup">{Helpers.renderDate(t.startDate)}</td>
            <td className="showGrup">{Helpers.renderDate(t.endDate)}</td>
            {/* <td className="showGrup">{t.isSuccess}</td> */}
            {/* <td className="showGrup">{this.renderScoreChart(t)}</td> */}
            <td className="u-centered">{this.renderDocumentIcon(t)}</td>
            <td className="u-centered">{this.renderCertificationIcon(t)}</td>
            <td>{this.renderContinueAction(t)}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr className={this.rowClassName} onClick={this.ToggleChildren}>
            {this.renderTrainingMethodIcon(t.method?.value)}
            <td className="showGrup">{this.renderTrainingName(t)}</td>
          </tr>
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { showModal, getCertificate })(
  CompletedTraining
);
